// extracted by mini-css-extract-plugin
export const btnPost = "success-module--btnPost--E27Gc";